import { t } from '@unistocks/localization';
import { Stack } from 'expo-router';

export default function AdminProfileLayout() {
  return (
    <Stack
      screenOptions={{
        headerShown: false
      }}
    >
      <Stack.Screen name={'menu'} options={{ title: t('::Menu:More') }} />
      <Stack.Screen name={'settings'} options={{ title: t('::Menu:Settings') }} />
      <Stack.Screen
        name={'edit-profile'}
        options={{ title: t('AbpAccount::ProfileTab:PersonalInfo') }}
      />
      <Stack.Screen
        name={'change-password'}
        options={{ title: t('AbpAccount::ProfileTab:Password') }}
      />
    </Stack>
  );
}
